import React, { useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
import { useIsInteractiveMode } from "../contexts/InteractiveContext";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: inherit;
`;
const SpacedHeading = styled.h2(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
  `
);
const EmptyAggregationContent = ({ toggleEdit, editing = false }) => {
  const { t } = useTranslation("aggregation");
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);
  const interactive = useIsInteractiveMode();
  const text = editing ? /* @__PURE__ */ React.createElement("p", null, t("builder_empty.editing"), /* @__PURE__ */ React.createElement("br", null), t("builder_empty.add_metric_hint"), /* @__PURE__ */ React.createElement("br", null), t("builder_empty.preview_hint", { button: t("wizard_common.update_preview") }), /* @__PURE__ */ React.createElement("br", null), t("builder_empty.finish_hint", { update: t("widgets:widget_edit.update"), cancel: t("common:actions.cancel") })) : /* @__PURE__ */ React.createElement("p", null, interactive ? /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "builder_empty.edit_hint_interactive",
      components: { editButton: /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: toggleEdit }) }
    }
  ) : t("builder_empty.edit_hint"));
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SpacedHeading, null, t("builder_empty.title")), text));
};
export default EmptyAggregationContent;
